import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import EyeDiseaseTemplate from "./sections/EyeDiseaseTemplate";
import AppoinmentSection from "../../components/appointment-section/AppoinmentSection";
import ASTIGMATISMIMG from "../../assets/images/eye-disease-astigmatism.jpg";
import GLAUCOMAIMG from "../../assets/images/eye-disease-glaucoma.jpg";
import DRYEYEIMG from "../../assets/images/eye-disease-dryeye.jpg";
import CATARACTIMG from "../../assets/images/eye-disease-cataract.jpg";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutEyeDisease",
  },
];

export default function EyeDisease() {
  const { t } = useTranslation();

  return (
    <StyledEyeDisease>
      <PageTop title={t("eyeDiseaseTitle")} linkList={linkChain} />
      <EyeDiseaseTemplate
        title="eyeDiseaseAstigatismTitle"
        text="eyeDiseaseAstigatismText"
        list={[
          "eyeDiseaseAstigatismList1",
          "eyeDiseaseAstigatismList2",
          "eyeDiseaseAstigatismList3",
        ]}
        img={ASTIGMATISMIMG}
      />
      <EyeDiseaseTemplate
        title="eyeDiseaseGlaucomaTitle"
        text="eyeDiseaseGlaucomaText"
        list={[
          "eyeDiseaseGlaucomaList1",
          "eyeDiseaseGlaucomaList2",
          "eyeDiseaseGlaucomaList3",
        ]}
        img={GLAUCOMAIMG}
        reverse={true}
      />
      <AppoinmentSection />
      <EyeDiseaseTemplate
        title="eyeDiseaseDryEyeTitle"
        text="eyeDiseaseDryEyeText"
        list={[
          "eyeDiseaseDryEyeList1",
          "eyeDiseaseDryEyeList2",
          "eyeDiseaseDryEyeList3",
        ]}
        img={DRYEYEIMG}
      />
      <EyeDiseaseTemplate
        title="eyeDiseaseCataractTitle"
        text="eyeDiseaseCataractText"
        list={[
          "eyeDiseaseCataractList1",
          "eyeDiseaseCataractList2",
          "eyeDiseaseCataractList3",
        ]}
        img={CATARACTIMG}
        reverse={true}
      />
    </StyledEyeDisease>
  );
}

const StyledEyeDisease = styled.main``;
